import axiosClient from '../configs/axios';


class ProductionentryService {
    // Get list 
    async getProductionEntryList(params) {
        try {
            const login_details = sessionStorage.getItem("loginUser");
        const userD = JSON.parse(login_details);
        const userInfo = userD?.result?.userInfo;
        

        const unit_id = userInfo?.depot_id || userInfo?.plant_id ;
            const response = await axiosClient.get(
                `/production-entry/list?page=${params.page}&&size=${params.size}&&searchKey=${params.searchKey}&unit_id=${unit_id}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }




    async  getProductionEntryReport(params) {
    try {
        const login_details = sessionStorage.getItem("loginUser");
        const userD = JSON.parse(login_details);
        const userInfo = userD?.result?.userInfo;
        const unit_id = userInfo?.depot_id || userInfo?.plant_id;
        let { fromDate, toDate, searchKey = '', page = 0, size = 10 } = params;

        // Validate input dates
        if (!fromDate || !toDate) {
            throw new Error("Both fromDate and toDate are required");
        }

        // Convert to Date objects and validate
        const fromDateObj = new Date(fromDate);
        const toDateObj = new Date(toDate);

        if (isNaN(fromDateObj.getTime()) || isNaN(toDateObj.getTime())) {
            throw new Error("Invalid date format for fromDate or toDate");
        }

        // Ensure toDate is not before fromDate
        if (toDateObj < fromDateObj) {
            throw new Error("toDate cannot be before fromDate");
        }

        // Format the dates to yyyy/mm/dd
        const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}/${month}/${day}`;
        };

        // Format dates
        const formattedFromDate = formatDate(fromDateObj);
        const formattedToDate = formatDate(toDateObj);

        // Make API call
        const response = await axiosClient.get(
            `/production-entry/report?unit_id=${unit_id}&fromDate=${formattedFromDate}&toDate=${formattedToDate}&searchKey=${searchKey}&page=${page}&size=${size}`
        );
        return response.data;
    } catch (error) {
        console.error("Error in production-entry:", error.message);
        throw error;
    }
}


    // Add 
    async addProductionEntry(data) {
        try {
            const response = await axiosClient.post('/production-entry/add', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Edit or delete
    async editDeleteProductionEntry(data) {
        try {
            const response = await axiosClient.put(`/production-entry/editDelete`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

        // GET CYLINDER FOR PRODUCTION entry

    async getProductionCylinder(plant_id) {
        try {
            const response = await axiosClient.get(
                `/production-entry/cylinder?plant_id=${plant_id}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }



}

export default new ProductionentryService(); 